import React, {useCallback} from "react";
import {useForm} from "react-hook-form";
import {Subject} from "rxjs";
import {showToast} from "common";
import {useObservable} from "rxsupport";
import {ReportModal} from "../../form-components/ReportModal";
import {NoContactInput} from "../../domain";
import {NoContactForm} from "./NoContactForm";

type Props = {
    visible$: Subject<boolean>;
    onFinished: (formValues: NoContactInput | null) => Promise<void>;
    authorizationGuid?: string;
    skipValidation?: boolean;
};

export function NoContactFormModal({visible$, onFinished, authorizationGuid, skipValidation = false}: Props) {
    const visible = useObservable(visible$, false);

    const methods = useForm<NoContactInput>({
        defaultValues: {
            numberOfContactAttempts: '',
            initialTypeOfContact: '',
            typeOfContact: '',
            comments: '',
        }
    });

    const onCancel = useCallback(async () => {
        showToast.warning(`Submission for No Contact is cancelled`);
        methods.reset();
        visible$.next(false);
    }, [methods, visible$]);

    return (
        <ReportModal visible={visible} title={'No Contact'} onClose={onCancel}>
            <NoContactForm visible$={visible$}
                           methods={methods}
                           onFinished={onFinished}
                           onCancel={onCancel}
                           authorizationGuid={authorizationGuid}
                           externalLoading={false}
                           skipValidation={skipValidation}/>
        </ReportModal>
    );
}
